import { render, staticRenderFns } from "./VaccinePopup.vue?vue&type=template&id=a1365996&scoped=true&"
import script from "./VaccinePopup.vue?vue&type=script&lang=js&"
export * from "./VaccinePopup.vue?vue&type=script&lang=js&"
import style0 from "./VaccinePopup.vue?vue&type=style&index=0&id=a1365996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1365996",
  null
  
)

export default component.exports